import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import toast from "react-hot-toast";
import Icon from "@mdi/react";
import { mdiClose, mdiLoading } from "@mdi/js";
import ProfilCheckOption from "./ProfilCheckOption";
import UserPrefsService from "../../../services/UserPrefsService";
import Style from "./CompteLeaderUsersList.scss";

const CompteLeaderUsersList = (props) => {
   const [loading, setLoading] = useState(false);
   const [users, setUsers] = useState();
   const [user, setUser] = useState();
   const [prefsAccess, setPrefsAccess] = useState();
   const userPrefsService = new UserPrefsService();

   useEffect(() => {
      getCollaborators();
   }, []);

   useEffect(() => {}, [props.isLeader]);

   const getCollaborators = async () => {
      setLoading(true);
      let result = await axios.get("/Api/entity/collaborators");
      setUsers(result.data);
      setLoading(false);
   };

   const handleUpdateUSerPrefs = async (e) => {
      const args = {
         userId: user.id,
         userPrefs: {
            ...user.prefs,
            access: {
               ...prefsAccess,
            },
         },
      };

      try {
         let result = await axios.post("/Api/user/prefs", args);
         result.data ? toast.success("Les informations de votre utilisateur ont bien été enregistrées") : null;
         getCollaborators();
      } catch (e) {
         toast.error("Un problème s'est produit et les informations de votre utilisateur n'ont pas été enregistrées.");
      }
   };
   const handleDelUSers = async (e) => {
      const args = {
         userId: user.id,
         role: props.role,
      };
      try {
         let result = await axios.delete("/Api/admin/user", {
            data: args,
         });
         result.data ? toast.success("L'utilisateur a été bien suprimé !") : null;
         getCollaborators();
      } catch (e) {
         toast.error("Un problème s'est produit et l'utilisateur n'a pas été supprimé.");
      }
   };

   useEffect(() => {
      if (user) {
         setPrefsAccess(updatePrefsAccess);
      }
   }, [user]);

   const updatePrefsAccess = () => {
      let access = userPrefsService.getInitialesPrefs().access;
      let result = [];
      if (user?.prefs?.access?.length) {
         access.map((item) => {
            result.push(user.prefs.access.find((e) => e.name === item.name) ?? item);
         });
         return result;
      } else {
         return access;
      }
   };

   const renderRow = (item, index) => {
      return (
         <tr key={index}>
            <td>
               <div className={"text-left"} style={{ padding: "5px" }}>
                  {" "}
                  {item.name}
               </div>
            </td>
            <td>
               <div className={"text-left "}> {item.forename}</div>
            </td>
            <td>
               <div className={"text-left "}> {item.email}</div>
            </td>
            <td>
               <div className={"text-left "}> {item.username}</div>
            </td>
            <td>{new Date(item.created_at).toLocaleDateString()}</td>
            <td>
               <div className={"text-center "}>
                  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <ellipse
                        cx="5"
                        cy="4.5"
                        rx="5"
                        ry="4.5"
                        fill={item?.id === props?.entity?.leader_id ? "#58D2C3" : "#CCCCCC"}
                     />
                  </svg>
               </div>
            </td>
            <td>
               <div className={"text-center "}>
                  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <ellipse cx="5" cy="4.5" rx="5" ry="4.5" fill={item.ip ? "#58D2C3" : "#CCCCCC"} />
                  </svg>
               </div>
            </td>
            <td>
               <div className={"text-center "}>
                  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <ellipse cx="5" cy="4.5" rx="5" ry="4.5" fill={item.two_factor_enabled ? "#58D2C3" : "#CCCCCC"} />
                  </svg>
               </div>
            </td>
            <td className={"text-right"}>
            {(props.role === "admin" || props.role === "gestion"||props.isLeader) ?( <div
                  className={"btn btn-sm btn-primary text-white"}
                  style={{
                     backgroundColor: "#FFBC6D",
                     borderColor: "#FFBC6D",
                     marginRight: "10px",
                     borderRadius: "10px",
                  }}
                  onClick={(e) => setUser(item)}
               >
                  <span
                     style={{
                        fontSize: "0.6rem",
                        fontWeight: "700",
                     }}
                  >
                     MODIFIER
                  </span>
               </div>):(<div></div>)}
            </td>
         </tr>
      );
   };

   const handleOnCheck = (e) => {
      let itemToChange = prefsAccess.find((item) => e.target.name === item.name);
      itemToChange.checked = !itemToChange.checked;
      let newData = [];
      prefsAccess.map((item) => {
         newData.push(item.id === itemToChange.id ? itemToChange : item);
      });
      setPrefsAccess(newData);
      handleUpdateUSerPrefs();
   };
   const renderCheck = (item, index) => {
      return (
         <ProfilCheckOption
            key={index}
            label={item.label}
            title={item.title}
            name={item.name}
            checked={item.checked}
            onCheck={handleOnCheck}
         />
      );
   };
   return (
      <div className={"d-flex flex-column justify-content-start w-100"}>
         {loading ? (
            <div className={"w-100 text-center"}>
               <Icon path={mdiLoading} spin={true} size={1.2} color={"var(--theme-primary)"} />
            </div>
         ) : users?.length ? (
            user ? (
               <div id={"ue-modal1-wrapper"} className={"ue-modal1-wrapper"}>
                  <div id={"ue-modal1"} className={"ue-modal1 d-flex flex-column h-100 w-100"}>
                     <div className={"w-100"}>
                        <div className={"d-flex flex-row justify-content-between align-items-center mb-2"}>
                           <div className={"h6 w-100 text-center"}>PARAMETRAGE DES DROITS DE CONSULTATION</div>
                           <div className={"ue-btn-icon-sm"} onClick={(e) => setUser(null)}>
                              <Icon className={"mx-2"} path={mdiClose} size={0.8} color={"var(--theme_primary)"} />
                           </div>
                        </div>

                        <div className={"d-flex flex-row justify-content-center align-items-center"}>
                           <div
                              style={{
                                 backgroundColor: "#F9F9F9",
                                 padding: "8px",
                                 width: "100%",
                                 borderRadius: "5px",
                                 marginBottom: "15px",
                                 fontSize: "10px",
                              }}
                           >
                              <span className={"font-weight-bold text-primary"}>{user.email}</span>
                           </div>
                        </div>
                        <div className={"w-100 overflow-auto"} style={{ fontSize: "10px" }}>
                           {prefsAccess
                              ? prefsAccess
                                   .filter((item) => item.label === "Shop")
                                   .map((item, index) => renderCheck(item, index))
                              : null}

                           {prefsAccess
                              ? prefsAccess
                                   .filter((item) => item.label === "Forfait")
                                   .map((item, index) => renderCheck(item, index))
                              : null}

                           {prefsAccess
                              ? prefsAccess
                                   .filter((item) => item.label === "Option")
                                   .map((item, index) => renderCheck(item, index))
                              : null}
                           {(props.role === "admin" || props.role === "gestion") && (
                              <div className={"d-flex flex-column justify-content-start w-100 mt-3"}>
                                 <div
                                    className={"d-flex justify-content-between align-items-center p-2 w-100 rounded"}
                                    style={{
                                       backgroundColor: "#d8b4b442",
                                    }}
                                 >
                                    <div
                                       type="btn"
                                       className={""}
                                       style={{ color: "red", cursor: "pointer" }}
                                       name={"Supprimer"}
                                       onClick={(e) => {
                                          handleDelUSers();
                                       }}
                                    >
                                       {"Supprimer le compte"}
                                    </div>
                                 </div>
                              </div>
                           )}
                        </div>
                     </div>
                  </div>
               </div>
            ) : (
               <div className="table-responsive">
                  <table className={"table table-sm ue-dashboard-table-v3 ue-invoice-table"}>
                     <thead className="">
                        <tr>
                           <th>Nom</th>
                           <th>Prénom</th>
                           <th>Email</th>
                           <th>Identifiant</th>
                           <th>Créé le</th>
                           <th className={"text-center"}>Admin</th>
                           <th className={"text-center"}>Access IP</th>
                           <th className={"text-center"}>Authent. à 2 facteurs</th>
                        </tr>
                     </thead>
                     <tbody className="table-light">{users.map((item, index) => renderRow(item, index))}</tbody>
                  </table>
               </div>
            )
         ) : (
            <div className={"text-center p-3 my-2"}>Vous n'avez pas encore d'autres collaborateurs</div>
         )}
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
      entity: state.MeReducer.entity,
      userPrefs: state.MeReducer?.prefs,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(CompteLeaderUsersList);
